import { useEffect } from 'react'
import { popModalLayer, pushModalLayer } from '../lib/modalLayer'

/** Register this modal with the global layer (body class + Sidebar hide). Stack-safe. */
export function useModalLayerPresence(isOpen: boolean): void {
  useEffect(() => {
    if (!isOpen) return
    pushModalLayer()
    return () => popModalLayer()
  }, [isOpen])
}
